import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import {
  AllInstruments,
  Instrument,
} from '@prlw/core/monitor/all-instruments.entity';
import { AllTableColumn } from '@prlw/core/monitor/types/all-table';
import { Destination } from '@prlw/core/destinations/destination.entity';
import { BasisDetailsInterface } from '../../../basis-details.interface';
import { BasisDetails } from '../../../basis-details.class';
import { Modifier } from '@prlw/core/monitor/types/common';

@Component({
  selector: 'prlw-all-table-column-content-ui',
  templateUrl: './column-content.component.html',
  styleUrls: ['./column-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableColumnContentComponent implements OnInit {
  @Input() public data!: AllInstruments;
  @Input() public column!: AllTableColumn;
  @Input() public modifiers: Modifier | null = null;
  @Input() public destination: Destination | null = null;
  public instrument!: Instrument | undefined;
  public readonly BASIS = 'Завод';

  public get trend(): string {
    return this.instrument?.forecast?.trend ?? '';
  }

  public ngOnInit(): void {
    if (this.column.name !== this.BASIS) {
      this.instrument = this.data.instrumentsByProductGroup[this.column.name];
    }
  }

  public get basisDetails(): BasisDetailsInterface | null {
    return this.instrument ? BasisDetails.fromAllInstruments(this.data) : null;
  }
}
